module.exports = "/_next/static/images/StayingAheadOfTheCurve-sm@2x-88a0a214baf61bea50910fe2bd257517.png";